export const model_load_docs = () => {
    return {
        docs: {
            customer: { value: null, type: "text" },
            category: { value: null, type: "text" },
            name: { value: null, type: "text" }
        },
        catalogs: { customer: [], category: [] },
    }
}